import Seo from '@/components/public/Seo';
import { parishName, parishLogo, useSite } from '@/hooks/useSite';

export default function ComingSoon() {
  const site = useSite();
  const name = parishName(site);

  return (
    <main className="bg-background flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <Seo title="Em breve" description="Estamos a preparar o novo site da freguesia." />
      <div className="gov-rule fixed inset-x-0 top-0" />

      {site.logoUrl && (
        <img src={parishLogo(site)} alt={`Brasão de ${name}`} className="mb-8 h-28 w-auto" />
      )}

      <p className="text-secondary text-xs font-bold tracking-[0.18em] uppercase">
        {site.officialName ? name : 'Freguesia'}
      </p>
      <h1 className="font-headline text-on-surface mt-3 max-w-2xl text-3xl leading-tight font-semibold sm:text-4xl">
        Estamos a preparar o nosso novo site.
      </h1>
      <p className="text-on-surface-light mt-4 max-w-xl text-base leading-relaxed">
        Estamos a trabalhar para lhe trazer o melhor da sua freguesia. O site estará disponível em
        breve.
      </p>

      {site.contactEmail && (
        <p className="text-on-surface-light mt-8 text-sm">
          Entretanto, pode contactar-nos:{' '}
          <a href={`mailto:${site.contactEmail}`} className="text-primary font-semibold underline">
            {site.contactEmail}
          </a>
        </p>
      )}
    </main>
  );
}

ComingSoon.layout = null;
